/* ============================================================
   Fibrolab — mejoras de la página de producto
   1) Barra sticky de "Agregar al carrito"
   2) Productos vistos recientemente (localStorage)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function resizeUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';
    var locale = document.documentElement.lang || 'es-CL';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return '$' + Math.round(amount).toLocaleString('es-CL');
    }
  }

  /* ============================================================
     1) STICKY ADD-TO-CART
     ============================================================ */
  function initStickyATC() {
    var bar = document.querySelector('[data-fb-sticky-atc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var realSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!realSubmit) return;

    var mainPrice = document.getElementById('price-' + sectionId);
    var stickyPrice = document.getElementById('FbStickyPrice-' + sectionId);
    var stickyImg = document.getElementById('FbStickyImage-' + sectionId);
    var stickyBtn = bar.querySelector('[data-fb-sticky-add]');
    var stickyBtnText = bar.querySelector('.fb-sticky-atc__btn-text');

    // El botón sticky dispara el botón real → reutiliza toda la lógica de Dawn.
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!realSubmit.disabled && realSubmit.getAttribute('aria-disabled') !== 'true') realSubmit.click();
      });
    }

    function syncPrice() {
      if (!mainPrice || !stickyPrice) return;
      // Copy only the selected variant's amounts, never campaign badges or PDP content.
      var price = mainPrice.querySelector('.price');
      if (!price) return;
      var onSale = price.classList.contains('price--on-sale');
      var current = price.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular:not(s)');
      var compare = onSale && !price.classList.contains('price--no-compare') ? price.querySelector('.price__sale s') : null;
      var stickyCurrent = stickyPrice.querySelector('[data-fb-sticky-current]');
      var stickyCompare = stickyPrice.querySelector('[data-fb-sticky-compare]');
      var compareWrap = stickyPrice.querySelector('[data-fb-sticky-compare-wrap]');
      if (current && stickyCurrent) stickyCurrent.textContent = current.textContent.trim();
      if (stickyCompare) stickyCompare.textContent = compare ? compare.textContent.trim() : '';
      if (compareWrap) compareWrap.hidden = !compare;
    }

    function syncButton() {
      if (!stickyBtn) return;
      var loading = realSubmit.classList.contains('loading');
      var disabled = realSubmit.disabled || (!loading && realSubmit.getAttribute('aria-disabled') === 'true');
      stickyBtn.disabled = disabled || loading;
      stickyBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      stickyBtn.classList.toggle('is-loading', loading);
      bar.classList.toggle('fb-sticky-atc--disabled', disabled);
      var spinner = stickyBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
      if (realSubmit.hasAttribute('aria-haspopup')) stickyBtn.setAttribute('aria-haspopup', realSubmit.getAttribute('aria-haspopup'));
      if (stickyBtnText) {
        var realText = realSubmit.querySelector('span');
        stickyBtnText.textContent = loading ? 'Agregando…' : disabled && realText ? realText.textContent.trim() : 'Agregar';
        stickyBtn.setAttribute('aria-label', loading ? 'Agregando al carrito' : disabled && realText ? realText.textContent.trim() : 'Agregar al carrito');
      }
    }

    syncPrice();
    syncButton();

    if (mainPrice) {
      new MutationObserver(syncPrice).observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }
    new MutationObserver(syncButton).observe(realSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
    });

    // Cambio de variante → actualizar imagen + re-sincronizar precio/botón.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event.data || event.data.sectionId !== sectionId) return;
        var variant = event && event.data && event.data.variant;
        if (variant && variant.featured_media && stickyImg) {
          var preview = variant.featured_media.preview_image;
          var src = preview && preview.src;
          if (src) stickyImg.src = resizeUrl(src, 120);
          if (preview && preview.alt) stickyImg.alt = preview.alt;
        }
        setTimeout(function () {
          syncPrice();
          syncButton();
        }, 0);
      });
    }

    // Mostrar la barra solo cuando el usuario ya hizo scroll PAST el botón real.
    // (No basta con que el botón no esté en pantalla: si está más abajo en el fold
    // tampoco debe mostrarse la barra todavía).
    var anchor = realSubmit.closest('.product-form__buttons') || realSubmit;
    // La altura real reserva espacio al final de la página y separa WhatsApp,
    // incluso al cambiar de variante, añadir instalación o girar el teléfono.
    function measureStickyATC() {
      document.documentElement.style.setProperty('--fb-sticky-atc-height', bar.offsetHeight + 'px');
    }
    new ResizeObserver(measureStickyATC).observe(bar);
    measureStickyATC();

    var ticking = false;
    function updateVisibility() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();
  }

  // One short sheen when the main purchase button enters the viewport.
  // The sticky button uses its existing visibility state for the same effect.
  function initATCMotion() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (productInfo) {
      var button = document.getElementById('ProductSubmitButton-' + productInfo.dataset.section);
      if (!button) return;
      button.classList.add('fls-atc-motion');
      if (typeof IntersectionObserver === 'undefined') return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('fls-atc-motion--visible', entry.isIntersecting);
        });
      }, { threshold: 0.65 }).observe(button);
    });
  }

  /* ============================================================
     2) VISTOS RECIENTEMENTE
     ============================================================ */
  var RV_KEY = 'fb_recently_viewed';
  var RV_MAX = 12;

  function getRV() {
    try {
      return JSON.parse(localStorage.getItem(RV_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setRV(arr) {
    try {
      localStorage.setItem(RV_KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  function currentHandle(section) {
    if (section && section.getAttribute('data-current-handle')) {
      return section.getAttribute('data-current-handle');
    }
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildCard(handle, product) {
    if (!product) return '';
    var img = product.featured_image ? resizeUrl(product.featured_image, 400) : '';
    var price = formatMoney(product.price);
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var compare = onSale ? formatMoney(product.compare_at_price) : '';
    return (
      '<li class="fb-rv__card">' +
        '<a class="fb-rv__link" href="/products/' + handle + '">' +
          (img
            ? '<div class="fb-rv__media"><img src="' + img + '" alt="' + escapeHtml(product.title) +
              '" loading="lazy" width="400" height="400"></div>'
            : '') +
          '<div class="fb-rv__body">' +
            (product.vendor ? '<p class="fb-rv__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
            '<p class="fb-rv__title">' + escapeHtml(product.title) + '</p>' +
            '<p class="fb-rv__price">' +
              (onSale ? '<s>' + compare + '</s> ' : '') +
              '<span' + (onSale ? ' class="fb-rv__price--sale"' : '') + '>' + price + '</span>' +
            '</p>' +
          '</div>' +
        '</a>' +
      '</li>'
    );
  }

  function fetchCard(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        return buildCard(handle, p);
      })
      .catch(function () {
        return '';
      });
  }

  function initRecentlyViewed() {
    var section = document.querySelector('[data-fb-recently-viewed]');
    var handle = currentHandle(section);
    var stored = getRV();

    if (section) {
      var grid = section.querySelector('[data-fb-rv-grid]');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
      var toShow = stored
        .filter(function (h) {
          return h !== handle;
        })
        .slice(0, limit);

      if (grid && toShow.length > 0) {
        Promise.all(toShow.map(fetchCard)).then(function (cards) {
          var html = cards
            .filter(function (c) {
              return c;
            })
            .join('');
          if (html) {
            grid.innerHTML = html;
            section.hidden = false;
          }
        });
      }
    }

    // Registrar el producto actual para próximas visitas.
    if (handle) {
      var list = stored.filter(function (h) {
        return h !== handle;
      });
      list.unshift(handle);
      setRV(list.slice(0, RV_MAX));
    }
  }

  /* ============================================================
     3) (libre) — aquí vivía initDetailsTabs
     ============================================================
     Convertía [data-fb-tabs] en pestañas en escritorio y en acordeón bajo
     749 px. La zona de detalles pasó a ser una sección propia con <details>
     nativos, que no necesitan JavaScript, no dejan seis de siete paneles con
     [hidden] en el primer pintado y no producen el salto de alto que causaba
     añadir .is-ready en DOMContentLoaded. */

  /* ============================================================
     4) GALERÍA MÓVIL: swipe gestionado por JS
     El carrusel nativo (overflow-x + scroll-snap) se tragaba los gestos
     verticales en iOS: con el dedo sobre la foto la página no scrolleaba.
     Solución: en móvil se desactiva el scroll táctil nativo del carrusel
     (touch-action: pan-y + overflow-x hidden vía .fb-swipe-managed) → el
     gesto vertical SIEMPRE scrollea la página y la foto no se mueve.
     El swipe horizontal lo implementamos nosotros con pointer events:
     arrastra el scrollLeft y al soltar aterriza en la foto siguiente/previa.
     ============================================================ */
  function initGallerySwipe() {
    var mq = window.matchMedia('(max-width: 749px)');
    var sliders = document.querySelectorAll('.product__media-wrapper .product__media-list.slider--mobile');

    Array.prototype.forEach.call(sliders, function (slider) {
      var slideCount = slider.querySelectorAll('.slider__slide').length;
      if (slideCount < 2) return; // una sola foto: nada que deslizar

      var itemOffset = 0;
      var nSlides = slideCount;
      var mode = null; // null | 'v' | 'h'
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var startT = 0;
      var suppressClick = false;

      function applyMode() {
        slider.classList.toggle('fb-swipe-managed', mq.matches);
      }
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', applyMode);
      else if (typeof mq.addListener === 'function') mq.addListener(applyMode);
      applyMode();

      function measure() {
        // el cambio de variante puede reordenar los <li>: medir en cada gesto
        var s = slider.querySelectorAll('.slider__slide');
        nSlides = s.length;
        var off = s.length > 1 ? Math.abs(s[1].offsetLeft - s[0].offsetLeft) : 0;
        if (!(off > 8)) {
          var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
          off = (s[0] ? s[0].offsetWidth : slider.clientWidth) + gap;
        }
        itemOffset = off;
      }

      function decideMode(x, y) {
        var dx = x - startX;
        var dy = y - startY;
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        // empate → vertical: prioridad al scroll de la página
        mode = Math.abs(dy) >= Math.abs(dx) ? 'v' : 'h';
        if (mode === 'h') measure();
      }

      slider.addEventListener('pointerdown', function (e) {
        if (!mq.matches || e.pointerType === 'mouse') return;
        mode = null;
        startX = e.clientX;
        startY = e.clientY;
        // cancela un aterrizaje smooth en curso para arrancar donde está
        slider.scrollLeft = slider.scrollLeft;
        startLeft = slider.scrollLeft;
        startT = Date.now();
      });

      slider.addEventListener('pointermove', function (e) {
        if (!mq.matches || e.pointerType === 'mouse') return;
        if (mode === null) {
          decideMode(e.clientX, e.clientY);
          if (mode === 'h') {
            try {
              slider.setPointerCapture(e.pointerId);
            } catch (err) {
              /* noop */
            }
          }
        }
        if (mode === 'h') slider.scrollLeft = startLeft - (e.clientX - startX);
      });

      // el touchmove también decide el eje (puede llegar antes que el
      // pointermove) y, en modo horizontal, evita que el navegador arranque
      // el scroll vertical de la página a mitad de gesto
      slider.addEventListener(
        'touchmove',
        function (e) {
          if (!mq.matches) return;
          if (mode === null && e.touches.length === 1) {
            decideMode(e.touches[0].clientX, e.touches[0].clientY);
          }
          if (mode === 'h') e.preventDefault();
        },
        { passive: false }
      );

      function landOn(index) {
        var max = slider.scrollWidth - slider.clientWidth;
        var target = Math.max(0, Math.min(nSlides - 1, index));
        var left = Math.min(target * itemOffset, max);
        slider.scrollTo({ left: left, behavior: 'smooth' });
      }

      slider.addEventListener('pointerup', function (e) {
        if (mode !== 'h') {
          mode = null;
          return;
        }
        mode = null;
        var totalDx = e.clientX - startX;
        var dt = Math.max(1, Date.now() - startT);
        var base = Math.round(startLeft / itemOffset);
        // el más cercano a la posición actual (respeta arrastres largos)…
        var index = Math.round(slider.scrollLeft / itemOffset);
        // …y un flick corto/rápido garantiza avanzar al menos una foto
        if (index === base && (Math.abs(totalDx) > 40 || Math.abs(totalDx / dt) > 0.3)) {
          index = base + (totalDx < 0 ? 1 : -1); // izquierda = siguiente
        }
        landOn(index);
        if (Math.abs(totalDx) > 10) {
          // que el arrastre no abra el lightbox
          suppressClick = true;
          setTimeout(function () {
            suppressClick = false;
          }, 300);
        }
      });

      slider.addEventListener('pointercancel', function () {
        if (mode === 'h') landOn(Math.round(slider.scrollLeft / itemOffset));
        mode = null;
      });

      slider.addEventListener(
        'click',
        function (e) {
          if (suppressClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initATCMotion();
    initStickyATC();
    initRecentlyViewed();
    initGallerySwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
